import { JSX } from "react";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";

function SegmentSeparator(): JSX.Element {
  return <QesIcon iconName={QesIcons.ChevronRightDouble} isDecorative className="align-text-top mlr5" />
}

export { SegmentSeparator };
